import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=47b5de06&scoped=true&lang=html&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5de06",
  null
  
)

export default component.exports